// extracted by mini-css-extract-plugin
module.exports = {"container":"GP-z","links":"HP-z"};